import React, {FunctionComponent} from "react";
import {DialogButton} from "../dialogButton";
import {OpenSiteModalType} from "../../enums";
const styles = require("./demoRequestCard.component.scss");

interface DemoRequestCardProps {
    title: string;
    subtitle: string;
    ctaText: string;
    modalType: OpenSiteModalType;
}


export const DemoRequestCard: FunctionComponent<DemoRequestCardProps> = props => {
    const {title, subtitle, ctaText, modalType} = props;
    return (
        <div className={styles.container}>
            <div className={styles.requestDemoTextContainer}>
                <h2>
                    {title}
                </h2>
                <div className={styles.requestDemoSubTitle}>
                    {subtitle}
                </div>
            </div>
            <div className={styles.requestDemoButtonContainer}>
                <DialogButton text={ctaText} modalType={modalType} buttonProps={{type: 'tertiary'}}/>
            </div>
        </div>
    );
};
